import React from "react";
import { useSelector } from "react-redux";
import OnBoardingHeader from "../../../Components/OnBoarding/OnBoardingHeader";
import OnBoardingSlide from "../../../Components/OnBoarding/OnBoardingSlide";
import OnBoardingContainer from "../../../Components/OnBoarding/OnBoardingContainer";

const BookingsLogsOnboarding = (props) => {

    const buildingName = useSelector(state => state.global.siteTitle) ?? 'Locale';

    return (
        <OnBoardingContainer
            module={'BOOKINGS'}
            tag="bookings_log"
            height={'22rem'}
        >
            <OnBoardingHeader>
                What's new with bookings
            </OnBoardingHeader>
            {/*    /!*TODO - Include QR code?*!/*/}
            {/*<OnBoardingSlide>*/}
            {/*    <p>You can now manage upcoming bookings and create new bookings on the go using the mobile app.</p>*/}
            {/*    <p>Find the app on the app store, so you can have {buildingName} at your fingertips, all of the time!</p>*/}
            {/*    /!*<img src="/public/img/modules/bookings/app-qr.png" draggable="false"/2>*!/*/}
            {/*</OnBoardingSlide>*/}
            <OnBoardingSlide>
                <p>We have updated the layout of upcoming bookings so you know what to expect next.</p>
                <p>Our improved search and filtering features also make it easier to locate bookings on the system.</p>
                <img src="/public/img/modules/bookings/bookings-onboarding-logs.png" draggable="false"/>
            </OnBoardingSlide>
        </OnBoardingContainer>
    )
}

export default BookingsLogsOnboarding;
